import SEO from "@/components/SEO";
import { FadeUp } from "@/components/Reveal";

function LegalLayout({ title, updated, children, testid }) {
  return (
    <section data-testid={testid} className="mx-auto max-w-3xl px-5 py-16 md:py-24">
      <FadeUp>
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-primary">Juridisch</p>
        <h1 className="mt-4 font-display text-4xl font-semibold tracking-tighter text-ink md:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">Laatst bijgewerkt: {updated}</p>
      </FadeUp>
      <FadeUp delay={0.15}>
        <div className="prose-neutral mt-10 space-y-8 text-sm leading-relaxed text-muted-foreground md:text-base">
          {children}
        </div>
      </FadeUp>
    </section>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-medium tracking-tight text-ink">{title}</h2>
      <p className="mt-3">{children}</p>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <>
      <SEO title="Privacyverklaring | Directelabels" description="Lees hoe Directelabels omgaat met uw persoonsgegevens." />
      <LegalLayout title="Privacyverklaring" updated="juli 2026" testid="privacy-page">
        <Block title="1. Welke gegevens verzamelen wij?">
          Wanneer u een aanvraag indient of het contactformulier invult, verzamelen wij de gegevens die u zelf invult:
          uw naam, contactgegevens, adresgegevens van de woning en eventuele opmerkingen.
        </Block>
        <Block title="2. Waarvoor gebruiken wij uw gegevens?">
          Wij gebruiken uw gegevens uitsluitend om uw aanvraag of vraag te behandelen: het plannen van de energieopname,
          het opstellen van een offerte en de communicatie hierover. Wij verkopen uw gegevens nooit aan derden.
        </Block>
        <Block title="3. Bewaartermijn">
          Wij bewaren uw gegevens niet langer dan noodzakelijk voor de afhandeling van uw aanvraag en eventuele
          wettelijke verplichtingen.
        </Block>
        <Block title="4. Uw rechten">
          U heeft recht op inzage, correctie en verwijdering van uw persoonsgegevens. Neem hiervoor contact met ons op
          via het contactformulier. U kunt tevens een klacht indienen bij de Autoriteit Persoonsgegevens.
        </Block>
        <Block title="5. Beveiliging">
          Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen tegen verlies of
          onrechtmatige verwerking.
        </Block>
      </LegalLayout>
    </>
  );
}

export function VoorwaardenPage() {
  return (
    <>
      <SEO title="Algemene voorwaarden | Directelabels" description="De algemene voorwaarden van Directelabels." />
      <LegalLayout title="Algemene voorwaarden" updated="juli 2026" testid="voorwaarden-page">
        <Block title="1. Toepasselijkheid">
          Deze voorwaarden zijn van toepassing op alle aanvragen, offertes en overeenkomsten tussen EnergieLabel
          Nederland en de opdrachtgever.
        </Block>
        <Block title="2. Aanvraag en offerte">
          Een aanvraag via de website is vrijblijvend. Er komt pas een overeenkomst tot stand nadat u de offerte heeft
          geaccepteerd. Alle offertes zijn vrijblijvend, tenzij anders aangegeven.
        </Block>
        <Block title="3. Uitvoering">
          Wij spannen ons in de energieopname zorgvuldig en op het afgesproken moment uit te voeren. De uiteindelijke
          registratie van het energielabel vindt plaats in EP-online.
        </Block>
        <Block title="4. Annulering">
          Een geplande opname kunt u kosteloos verzetten of annuleren tot 48 uur voor de afspraak. Daarna kunnen
          kosten in rekening worden gebracht.
        </Block>
        <Block title="5. Aansprakelijkheid">
          Wij zijn niet aansprakelijk voor indirecte schade. Onze aansprakelijkheid is in alle gevallen beperkt tot het
          bedrag van de betreffende opdracht.
        </Block>
      </LegalLayout>
    </>
  );
}

export function CookiesPage() {
  return (
    <>
      <SEO title="Cookieverklaring | Directelabels" description="Lees welke cookies Directelabels gebruikt." />
      <LegalLayout title="Cookieverklaring" updated="juli 2026" testid="cookies-page">
        <Block title="1. Wat zijn cookies?">
          Cookies zijn kleine tekstbestanden die bij het bezoeken van een website op uw apparaat worden opgeslagen.
        </Block>
        <Block title="2. Welke cookies gebruiken wij?">
          Deze website gebruikt functionele cookies die noodzakelijk zijn voor het goed werken van de site, en
          analytische cookies waarmee wij het gebruik van de website anoniem meten om deze te verbeteren.
        </Block>
        <Block title="3. Cookies beheren">
          Via de instellingen van uw browser kunt u cookies verwijderen of blokkeren. Houd er rekening mee dat de
          website zonder functionele cookies mogelijk minder goed werkt.
        </Block>
      </LegalLayout>
    </>
  );
}
